import { Helmet } from 'react-helmet-async';

interface GoogleAnalyticsProps {
  measurementId?: string;
  gtmId?: string;
  searchConsoleVerification?: string;
}

/**
 * GoogleAnalytics - Enhanced tracking and analytics setup
 * Includes GA4, GTM, and conversion tracking
 */
const GoogleAnalytics: React.FC<GoogleAnalyticsProps> = ({
  measurementId = "G-6XVE1966N1", // Punto Hispano GA4 ID
  gtmId, // Optional GTM ID
  searchConsoleVerification
}) => {
  return (
    <Helmet>
      {/* Google Tag Manager - only if valid GTM ID is provided */}
      {gtmId && gtmId !== "GTM-XXXXXXX" && (
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmId}');`}
        </script>
      )}

      {/* Google Analytics 4 */}
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}', {
            page_title: document.title,
            page_location: window.location.href,
            custom_map: {
              'dimension1': 'service_category',
              'dimension2': 'user_language'
            }
          });
          
          // Enhanced Ecommerce tracking for service inquiries
          gtag('config', '${measurementId}', {
            'custom_map.dimension1': 'service_category'
          });
          
          // Conversion tracking
          gtag('event', 'page_view', {
            page_title: document.title,
            page_location: window.location.href,
            language: 'es',
            country: 'CH'
          });
        `}
      </script>

      {/* Search Console Verification */}
      {searchConsoleVerification && (
        <meta name="google-site-verification" content={searchConsoleVerification} />
      )}
      
      {/* Bing Webmaster Tools */}
      <meta name="msvalidate.01" content="YOUR_BING_VERIFICATION_CODE" />

      {/* Google Tag Manager (noscript) - only if valid GTM ID is provided */}
      {gtmId && gtmId !== "GTM-XXXXXXX" && (
        <noscript>{`<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}</noscript>
      )}
    </Helmet>
  );
};

export default GoogleAnalytics;